import { createContext, useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';

export const PopupContext = createContext();

const PopupContextProvider = ({ children }) => {
  
  // Initialize state variable 'popup' with the result
  const [popup, setPopup] = useState(
    sessionStorage.getItem('popup') === null ||
      sessionStorage.getItem('popup') === 'true'
  );

  const [explorePopup, setExplorePopup] = useState(false);

  const closePopup = () => {
    sessionStorage.setItem('popup', 'false');
    setPopup(false);
  };

  return (
    <PopupContext.Provider
      value={{ popup, closePopup, explorePopup, setExplorePopup }}
    >
      {children}
    </PopupContext.Provider>
  );
};

PopupContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PopupContextProvider;
